import React, { createContext, useContext, useEffect, useRef } from 'react';
import { AuthContext } from './AuthContext';
import { FetchContext } from './FetchContext';

const HeartbeatContext = createContext();

const HEARTBEAT_INTERVAL_MS = 30 * 1000; // 30 seconds

const HeartbeatProvider = ({ children }) => {
    const authContext = useContext(AuthContext);
    const fetchContext = useContext(FetchContext);
    const intervalRef = useRef(null);

    const sendHeartbeat = async () => {
        try {
            const token = authContext.getToken();
            if (!token) return;
            
            await fetchContext.authAxios.post('/heartbeat', {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            // Silently fail - heartbeat is best-effort
            // Don't log to avoid console spam
        }
    };

    useEffect(() => {
        const isAuthenticated = authContext.isUserAuthenticated();

        if (isAuthenticated) {
            // Send initial heartbeat immediately
            sendHeartbeat();

            // Set up interval for subsequent heartbeats
            intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [authContext.authState]); // Re-run when auth state changes

    return (
        <HeartbeatContext.Provider value={{}}>
            {children}
        </HeartbeatContext.Provider>
    );
};

export { HeartbeatProvider, HeartbeatContext };

